import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { createMeal, createRoom, deleteMeal, deleteRoom, fetchMealById, fetchMealPlanReport, fetchMealsPlan, fetchMealsPlanRoom, fetchRooms, UpdateMeal, updateRoom } from "../../../service/api";


export const getMealRooms = createAsyncThunk(
    "meal/getrooms",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchMealsPlanRoom(params)
            console.log("meals rooms", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)



export const getExportMealPlan = createAsyncThunk(
    "meal/export",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchMealPlanReport(params)
            console.log("meals export", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getMealPlan = createAsyncThunk(
    "meal/getmeals",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchMealsPlan(params)
            console.log("meals plan", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)



export const getMealById = createAsyncThunk(
    "meal/ById",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchMealById(params)
            console.log("meals by id", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const deleteMeals = createAsyncThunk(
    "meals/delete",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await deleteMeal(formValue)
            if (response.status === 201) {
                console.log("delete", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const addMeals = createAsyncThunk(
    "meals/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createMeal(formValue)
            if (response.status === 201) {
                console.log("meals", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const editMealPlan = createAsyncThunk(
    "meals/edit",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await UpdateMeal(newData)
            if (response.status === 201) {
                console.log("edit meal", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)


const mealSlice = createSlice({
    name: "meals",
    initialState: {
        mealroomList: [],
        mealPlanList: [],
        mealPlanById: {},
        exportMealPlan: null,
        mealCount: {},
        defaultRoomId: null,
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchData: ""
    },
    reducers: {
        clearExportMealPlan: (state) => {
            state.exportMealPlan = null;
        },
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchData = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getMealRooms.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getMealRooms.fulfilled, (state, action) => {
                state.isLoading = false;
                state.mealroomList = action.payload.data;

                state.defaultRoomId = action.payload.data[0]?._id
                state.totalPage = action.payload.totalPages
            })
            .addCase(getMealRooms.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            // REPORT
            .addCase(getExportMealPlan.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getExportMealPlan.fulfilled, (state, action) => {
                state.isLoading = false;
                state.exportMealPlan = action.payload;

            })
            .addCase(getExportMealPlan.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })


            //meals plan
            .addCase(getMealPlan.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getMealPlan.fulfilled, (state, action) => {
                state.isLoading = false;
                state.mealPlanList = action.payload.data;
                state.mealCount = action.payload.mealCalculate
                state.totalPage = action.payload.totalPages
            })
            .addCase(getMealPlan.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //by id
            .addCase(getMealById.pending, (state) => {
                state.error = null
            })
            .addCase(getMealById.fulfilled, (state, action) => {
                state.mealPlanById = action.payload.data;
            })
            .addCase(getMealById.rejected, (state, action) => {
                state.error = action.payload
            })

            // POST
            .addCase(addMeals.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addMeals.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addMeals.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT
            .addCase(editMealPlan.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editMealPlan.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editMealPlan.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // delete
            .addCase(deleteMeals.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(deleteMeals.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(deleteMeals.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})

export const { setSearchParams, setPagination, clearExportMealPlan } = mealSlice.actions;

export default mealSlice.reducer;